// The knowledge feature (web-kb, p1h-web-5b): its tabs on a knowledge base's spec page.
import { registerKindTab } from "../../kinds/tabs";
import { DocumentsTab } from "./documents-tab";
import { GenerationsTab } from "./generations-tab";

registerKindTab({
  kind: "KnowledgeBase",
  id: "documents",
  labelKey: "knowledge.tabs.documents",
  order: 10,
  panel: DocumentsTab,
});
registerKindTab({
  kind: "KnowledgeBase",
  id: "generations",
  labelKey: "knowledge.tabs.generations",
  order: 20,
  panel: GenerationsTab,
});
